export default {
    camp: {
        name: "Camp",
        url: "nwcg_logistics/camp",
    },
    closure: {
        name: "Closure",
        url: "nwcg_logistics/closure",
    },
    drop_point: {
        name: "Drop Point",
        url: "nwcg_logistics/drop_point",
    },
    incident_command_post: {
        name: "Incident Command Post",
        url: "nwcg_logistics/incident_command_post",
    },
    medical: {
        name: "Medical",
        url: "nwcg_logistics/medical",
    },
    staging_area: {
        name: "Staging Area",
        url: "nwcg_logistics/staging_area",
    },
}
